export enum CourseSessionStatus {
  Approved = 4,
}

export enum CourseSessionAttendeeStatus {
  CertificateApproved = 5,
  CertificateAwarded = 6,
  AssessmentPeriodExpired = 7,
}